import { ROUTE_PATH } from 'constants/routePath';
import useAuth from 'hooks/useAuth';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingLayout from '../layout/LoadingLayout';

export type TProps = {
  children: React.ReactNode;
};

const RequiredAuth = ({ children }: TProps) => {
  const { isLogin: isLoginStorage } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoginStorage !== undefined) {
      setIsLoading(false);
    }
  }, [isLoginStorage]);

  if (isLoading) {
    return <LoadingLayout />;
  }

  if (isLoginStorage === null || (isLoginStorage && !isLoginStorage?.isLogin)) {
    return <Navigate replace to={ROUTE_PATH.common.LOGIN} />;
  }

  return <main className="main">{children}</main>;
};

export default RequiredAuth;
